import { RouterModule, Routes } from '@angular/router';
import { UserIndexComponent } from './index/UserIndexComponent';
import { MainLayoutComponent } from '../../../../core/layouts/main/MainLayoutComponent';
import { AuthService } from '../../../common/service/AuthService';
/** ルーティング設定 */
const routes: Routes = [
  {path: 'user',
    component: MainLayoutComponent,
    children: [
      { path : 'index/:tenantCd', component : UserIndexComponent, canActivate: [AuthService]  }
    ]
  }
];
export const UserRoutingModule = RouterModule.forChild(routes);